import { UniFiCategoryId } from "@ubnt/store.core/lib/constants/proStoreCategories/mapping/unifi";

import { UniFiChildCategorySlug } from "@ubnt/store.core/lib/constants/proStoreCategories/mapping/unifi";

import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/switching/enterprise/enterprise-campus-24-poe.png";
import type { Product } from "../../types";
import { productListSwitchingEnterprise } from "../product-list-groups/productListSwitchingEnterprise";
import {
  downlinkSpeed,
  etherlighting,
  mounting,
  outdoorReady,
  poeAvailability,
  poeOutput,
  portCount,
  powerMethod,
  proAvSupport,
  switchTechnology,
  uplinkSpeed,
} from "../properties";

export const enterpriseCampus24PoE: Product = {
  id: "enterpriseCampus24PoE",
  productTitle: "Enterprise Campus 24 PoE",
  techspecsPath: [
    SiteId.TechSpecs,
    `/unifi/${UniFiCategoryId.Switching}/ecs-24-poe`,
  ],
  storePathParts: {
    productSlug: "ecs-24-poe",
    category: UniFiChildCategorySlug.SwitchingEnterprise,
  },
  sku: "ECS-24",
  description: "enterpriseCampus24PoE.description",
  image: { src: image, width: 200, height: 140 },
  productListGroup: productListSwitchingEnterprise,
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "string",
        value: '442.4 x 43.7 x 496 mm\n(17.4 x 1.7 x 19.5")',
      },
    },
    {
      propertyId: switchTechnology.id,
      value: {
        type: "translation",
        value: "commons.switchingTechnology.layer3",
      },
    },
    {
      propertyId: portCount.id,
      value: { type: "string", value: "24" },
    },
    {
      propertyId: downlinkSpeed.id,
      value: {
        type: "translation",
        value: "commons.speed.upTo10Gbps",
      },
    },
    {
      propertyId: uplinkSpeed.id,
      value: { type: "string", value: "25 Gbps" },
    },
    {
      propertyId: poeOutput.id,
      value: { type: "string", value: "PoE+++" },
    },
    {
      propertyId: poeAvailability.id,
      value: { type: "string", value: "1050 W" },
    },
    {
      propertyId: etherlighting.id,
      value: { type: "boolean", value: true },
    },
    {
      propertyId: proAvSupport.id,
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "generalRedundancy",
      value: {
        type: "translation",
        value: "commons.powerRedundancy.dualHotSwappablePsus",
      },
    },
    {
      propertyId: powerMethod.id,
      value: {
        type: "translation",
        value: "commons.powerMethod.acPower",
      },
    },
    {
      propertyId: mounting.id,
      value: {
        type: "translation",
        value: "commons.mounting.rack",
      },
    },
    {
      propertyId: outdoorReady.id,
      value: { type: "boolean", value: false },
    },
  ],
};
